// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS DU COMPOSANT FORMBUILDER.JS */
.stylDivGB {
  width: 100%;
  min-height: 100vh;
}
.stylRowCard {
  /* background-color: #43CE0C; */
  width: 100%;
  margin-left: 8% !important;
}
.cardTitleDescriptionInput.ant-card {
  border-top: 10px solid #E8FCE2;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  box-shadow: none;
  padding: 0;
}

.cardTitleDescriptionInput.ant-card:focus,
.cardTitleDescriptionInput.ant-card:has(.ant-input:focus) {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-left: 7px solid #E8FCE2;
  outline: none;
}


.stylIconeFifileText {
  font-size: 35px;
  color: #43CE0C;
}
.stylCol1 {
  display: flex;
  align-items:center;
  justify-content: start;
  /* margin-bottom: -10%; */
}
.stylCol2 {
  position: relative;
  gap: 5%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 2%;
  flex-wrap: wrap;
}
.stylBoutonPub {
  background-color: #43CE0C;
  color: #fff;
  font-weight: 500;
  padding: 4%;
}
.stylBoutonIgnorer {
  background-color: transparent;
  color: #777676;
  font-weight: 500;
  padding: 4%;
  border: none;
  margin-right: 2%;
}
.stylColLateral {
  width: 90%;
  border-radius: 1rem;
  box-shadow: 0 8px 6px rgba(0, 0, 0, 0.1);
  padding: 2%;
  height: auto;
  position: absolute;
  left: 0;
   display: flex;
  flex-direction: column;
  align-items: center;
}



.stylDefaultCard {
  padding: 1%;
  box-shadow: 0 8px 6px rgba(0, 0, 0, 0.1);
  border-left: 7px solid #E8FCE2; 
}

/* Style normal */
.stylSelectEmail.ant-select {
   height: 8vh;
   width: 100%;
}
/* Style quand le champ est en focus */
.stylSelectEmail.ant-select:focus,
.stylSelectEmail.ant-select-focused {
  border: 2px solid #000; 
  /* min-height: 8vh; */
  border-radius: 0.5rem;
}
/* Sélecteur pour l'élément sélectionné visible (pas le menu déroulant) */
.stylSelectOptionModal2 .ant-select-selection-item {
  font-weight: bold;
}

.stylBtnSubmitForm {
  color: #fff;
  background-color: #43CE0C;
  padding: 2.7%;
  float: right;
}`, "",{"version":3,"sources":["webpack://./src/components/forms/forms.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,8BAA8B;EAC9B,wDAAwD;EACxD,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,wCAAwC;EACxC,8BAA8B;EAC9B,aAAa;AACf;;;AAGA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,wCAAwC;EACxC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;GACN,aAAa;EACd,sBAAsB;EACtB,mBAAmB;AACrB;;;;AAIA;EACE,WAAW;EACX,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;GACG,WAAW;GACX,WAAW;AACd;AACA,sCAAsC;AACtC;;EAEE,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;AACvB;AACA,yEAAyE;AACzE;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,YAAY;AACd","sourcesContent":["/* CSS DU COMPOSANT FORMBUILDER.JS */\r\n.stylDivGB {\r\n  width: 100%;\r\n  min-height: 100vh;\r\n}\r\n.stylRowCard {\r\n  /* background-color: #43CE0C; */\r\n  width: 100%;\r\n  margin-left: 8% !important;\r\n}\r\n.cardTitleDescriptionInput.ant-card {\r\n  border-top: 10px solid #E8FCE2;\r\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\r\n  box-shadow: none;\r\n  padding: 0;\r\n}\r\n\r\n.cardTitleDescriptionInput.ant-card:focus,\r\n.cardTitleDescriptionInput.ant-card:has(.ant-input:focus) {\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  border-left: 7px solid #E8FCE2;\r\n  outline: none;\r\n}\r\n\r\n\r\n.stylIconeFifileText {\r\n  font-size: 35px;\r\n  color: #43CE0C;\r\n}\r\n.stylCol1 {\r\n  display: flex;\r\n  align-items:center;\r\n  justify-content: start;\r\n  /* margin-bottom: -10%; */\r\n}\r\n.stylCol2 {\r\n  position: relative;\r\n  gap: 5%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  padding: 2%;\r\n  flex-wrap: wrap;\r\n}\r\n.stylBoutonPub {\r\n  background-color: #43CE0C;\r\n  color: #fff;\r\n  font-weight: 500;\r\n  padding: 4%;\r\n}\r\n.stylBoutonIgnorer {\r\n  background-color: transparent;\r\n  color: #777676;\r\n  font-weight: 500;\r\n  padding: 4%;\r\n  border: none;\r\n  margin-right: 2%;\r\n}\r\n.stylColLateral {\r\n  width: 90%;\r\n  border-radius: 1rem;\r\n  box-shadow: 0 8px 6px rgba(0, 0, 0, 0.1);\r\n  padding: 2%;\r\n  height: auto;\r\n  position: absolute;\r\n  left: 0;\r\n   display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n\r\n\r\n.stylDefaultCard {\r\n  padding: 1%;\r\n  box-shadow: 0 8px 6px rgba(0, 0, 0, 0.1);\r\n  border-left: 7px solid #E8FCE2; \r\n}\r\n\r\n/* Style normal */\r\n.stylSelectEmail.ant-select {\r\n   height: 8vh;\r\n   width: 100%;\r\n}\r\n/* Style quand le champ est en focus */\r\n.stylSelectEmail.ant-select:focus,\r\n.stylSelectEmail.ant-select-focused {\r\n  border: 2px solid #000; \r\n  /* min-height: 8vh; */\r\n  border-radius: 0.5rem;\r\n}\r\n/* Sélecteur pour l'élément sélectionné visible (pas le menu déroulant) */\r\n.stylSelectOptionModal2 .ant-select-selection-item {\r\n  font-weight: bold;\r\n}\r\n\r\n.stylBtnSubmitForm {\r\n  color: #fff;\r\n  background-color: #43CE0C;\r\n  padding: 2.7%;\r\n  float: right;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
